const storyMenu = ".wm-storyMenu";
const storyMenuMobile = ".wm-storyMenuMobile";
jQuery(document).on('ready', function () {
    var windowHeight = jQuery(window).height();
    var heightCheck = windowHeight * 0.8;
    jQuery(window).resize(function () {
        windowHeight = jQuery(window).height();
        heightCheck = windowHeight * 0.8;
    });
    var elementExists = document.getElementById('pre-surgery');
    if (elementExists != null) {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= heightCheck) {
            jQuery(storyMenu).addClass("-floatingMenu");
            jQuery(storyMenuMobile).addClass("-floatingMenu");
        }
        else {
            jQuery(storyMenu).removeClass("-floatingMenu");
            jQuery(storyMenuMobile).removeClass("-floatingMenu");
        }
        jQuery(window).scroll(function () {
            scroll = jQuery(window).scrollTop();
            if (scroll >= heightCheck && scroll < jQuery('#sign-up').offset().top - 600) {
                jQuery(storyMenu).addClass("-floatingMenu");
                jQuery(storyMenuMobile).addClass("-floatingMenu");
            }
            else {
                jQuery(storyMenu).removeClass("-floatingMenu");
                jQuery(storyMenuMobile).removeClass("-floatingMenu");
            }
        });
    }
});
